import { Component, inject, input, model } from '@angular/core';
import { GbTheme, THEME_SIGNAL } from '../../interfaces/theme';

@Component({
  selector: 'app-toggle',
  imports: [],
  templateUrl: './toggle.component.html',
  styleUrl: './toggle.component.scss',
})
export class ToggleComponent {
  public leftValue = input<string>('');
  public rightValue = input<string>('');
  public value = model<string>('');
  public theme = inject(THEME_SIGNAL);
  public leftHref = input<string>('#');
  public rightHref = input<string>('#');

  public GbTheme = GbTheme;

  public setModelValue(value: string) {
    this.value.set(value);
  }
}
